// extracted by mini-css-extract-plugin
export var alignLeft = "p_qD d_fp d_bG d_dv";
export var alignCenter = "p_bP d_fq d_bD d_dw";
export var alignRight = "p_qF d_fr d_bH d_dx";
export var FAQMainHeader = "p_kt d_kt d_w d_by";
export var FAQComponentHeader = "p_kz d_kz d_bx";
export var FAQComponentParagraph = "p_kv d_kv d_cD";
export var FAQComponentsWrapper = "p_kr d_kr d_cn d_cL d_cR d_c2 d_cX d_dB";
export var FAQComponentsWrapperClean = "p_ks d_ks d_cn d_cL d_cR d_c0 d_dB";
export var accordion__body = "p_kB d_kB d_by";
export var accordion__bodyHidden = "p_kD d_kD d_bw d_dl";
export var FAQDivider = "p_kq d_kq";
export var accordionWrapper = "p_qM d_cg";
export var accordion__item = "p_qN d_cL";
export var accordion_arrow = "p_kH d_kH";
export var accordion_arrow_open = "p_kK d_kK";
export var accordion_arrow_2 = "p_kM d_kM";
export var accordion_arrow_2_open = "p_kP d_kP";
export var Subtitle2Small = "p_qP t_qP t_rD t_rT";
export var Subtitle2Normal = "p_qQ t_qQ t_rD t_rV";
export var Subtitle2Large = "p_qR t_qR t_rD t_rW";